import * as React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { LinkContainerStyles, LinkStyles } from './styles';

export const StyledNoArrowLinkContainer = styled.div`
  ${LinkContainerStyles}
  display: block;
`;

const StyledLink = styled(Link)`
  ${LinkStyles}
`;
const StyledAnchor = styled.a`
  ${LinkStyles}
`;

export const NoArrowLink: React.FC<React.ComponentProps<
  typeof StyledLink | typeof StyledAnchor
>> = ({ children, ...props }) => {
  return <StyledLink {...props}>{children}</StyledLink>;
};
